<template lang="pug">
.Loading._stretch._flex._flex-alignItemsCenter._flex-justifyContentCenter(:class="{'_radius': radius}")
   //- .Icon.Animate--spin(:style="{width: iconSize, height: iconSize}"): include /../../../s-icons/icon-cog.svg
   .Icon.Animate--spin(:style="{width: iconSize, height: iconSize}"): include ./../../../s-icons/icon-cog.svg
   ._stretch._bg-white._alpha-70(:class="{'_radius': radius, '_none': background === 'off'}")
</template>

<style lang="sass" scoped>
.Loading 
   z-index: 400
.Icon 
   z-index: 500
   opacity: .8
   +wh(34px)
   svg
      width: 100%
      display: inherit
</style>

<script>
export default {
   name: 'Loading',
   props: {
      radius: Boolean,
      background: {
         type: String,
         default: 'on',
      },
      iconSize: String,
   },
}
</script>

